<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div class="d-flex align-items-center" style="gap: 10px">
        <div class="d-block">
          <div class="section-title">{{ $t("Vouchers And Offers") }}</div>
          <div class="section-subTitle my-2">
            {{ $t("promotionsandoffer_dashmsg") }}
          </div>
        </div>

        <div>
          <b-form-input
            v-debounce:300="getPromotionsAndOffersList"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
      </div>

      <!-- <div class="mx-2" style="display: grid; margin-left: 5px; justify-content: end; align-items: center; gap: 1px;">
        <b-dropdown id="offerGroupType" variant="outline-blue">
          <template v-slot:button-content>
            <strong>{{ selectedOfferVoucherTypeName }}</strong>
          </template>
          <b-dropdown-item
            v-for="groupType in selectedOfferVouchertype"
            :key="groupType.id"
            @click="onOfferVoucherTypeChange(groupType)"
          >
            {{ groupType.type }}
          </b-dropdown-item>
        </b-dropdown>
      </div> -->

      <div
        class="mx-2"
        style="display: grid; margin-left: 5px; justify-content: end; align-items: center; gap: 1px;"
      >
        <b-dropdown id="offerGroupType" variant="outline-blue">
          <template v-slot:button-content>
            <strong>{{ selectedOfferVoucherTypeName }}</strong>
          </template>
          <b-dropdown-item
            v-for="groupType in selectedOfferVouchertype"
            :key="groupType.id"
            @click="onOfferVoucherTypeChange(groupType)"
          >
            {{ groupType.type }}
          </b-dropdown-item>
        </b-dropdown>
      </div>

      <div class="d-flex align-items-center" style="gap: 10px">
        <div class="mx-2">
          <b-dropdown id="offerGroupType" variant="outline-blue">
            <template v-slot:button-content>
              <strong>{{ selectedOfferGroupTypeName }}</strong>
            </template>
            <b-dropdown-item
              v-for="groupType in offerGroupTypes"
              :key="groupType.ogt_id"
              @click="onOfferGroupTypeChange(groupType)"
            >
              {{ groupType.ogt_type_name }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
        <div>
          <b-button
            v-if="
              cinema_manager_add_edit_disabled != 3 &&
                $can('create', 'Promotions & Offers')
            "
            variant="default"
            to="add-promotions-and-offers-new"
            class="btn-blue"
            >{{ $t("add") }}</b-button
          >
        </div>

        <div class="">
          <FilterByStatusDropdown
            :onSelect="
              (filterIsActive) => {
                filter_is_active = filterIsActive;
                getPromotionsAndOffersList();
              }
            "
          />
        </div>

        <div class="mx-2">
          <b-dropdown id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <div
      class="d-flex justify-content-between align-items-center my-3"
      v-if="gridView && listView == true"
    >
      <div class="d-flex"></div>

      <button
        class="btnj btn-gridView mr-3"
        v-if="GridViewFlag"
        :class="gridView ? 'active' : ''"
        v-on:click="viewType('gridView')"
      ></button>
      <button
        class="btnj btn-listView"
        v-if="GridViewFlag"
        :class="listView ? 'active' : ''"
        v-on:click="viewType('listView')"
      ></button>
    </div>

    <!-- GRID VIEW -->

    <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-for="(PromotionOfferItem,
        PromotionOfferItemIndex) in promotionsAndOffersList"
        :key="PromotionOfferItemIndex"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>Active Promotions</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="
                    cinema_manager_add_edit_disabled != 3 &&
                      $can('update', 'Promotions & Offers')
                  "
                  @click.prevent.stop="onEditPromotionOffer(PromotionOfferItem)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click.prevent.stop="onViewPromotionOffer(PromotionOfferItem)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>

                <b-dropdown-item to="view-usage-promotions-and-offers">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }} Usage
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1">
              <div class="count">{{ PromotionOfferItem.offer_title }}</div>
            </div>
            <div class="d-flex align-items-end">
              <StatusDot
                :status="
                  PromotionOfferItem.os_is_active == 'Y'
                    ? 'active'
                    : PromotionOfferItem.os_is_active == 'N' && 'inactive'
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- LIST VIEW DESIGNATION -->
    <div
      class="desg-list-container"
      v-if="listView"
      style="margin-bottom: 15px; overflow-x: auto"
    >
      <table class="w-100" style="overflow-x: auto;">
        <thead>
          <tr class="desg-list-header11">
            <th style="">{{ $tc("status", 2) }}</th>
            <th style="">
              <span
                v-if="this.columnName != 'offer_title'"
                @click="onSortValue('offer_title', 'asc')"
                class="cursor-pointer"
              >
                <img
                  src="@/assets/img/icons/updown.svg"
                  width="15px"
                  height="20px"
                />
              </span>
              <span
                v-else-if="isSort && isAscending"
                @click="onSortValue('offer_title', 'asc')"
                class="cursor-pointer"
              >
                <img
                  src="@/assets/img/icons/asc.svg"
                  width="15px"
                  height="20px"
                />
              </span>
              <span
                v-else
                @click="onSortValue('offer_title', 'desc')"
                class="cursor-pointer"
              >
                <img
                  src="@/assets/img/icons/desc.svg"
                  width="15px"
                  height="20px"
                />
              </span>
              {{ $t("promotionsandoffer") }}
            </th>
            <th>Offer/Voucher</th>
            <th style="width: 150px">{{ $tc("From Date", 2) }}</th>
            <th style="width: 150px">{{ $tc("To Date", 2) }}</th>
            <th>{{ $tc("WEB", 2) }}</th>
            <th>{{ $tc("BO", 2) }}</th>
            <th>{{ $tc("CON", 2) }}</th>
            <th style="width: 186px">{{ $tc("Offer Group Type", 2) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-if="promotionsAndOffersList.length > 0"
            v-for="(PromotionOfferItem,
            PromotionOfferItemIndex) in promotionsAndOffersList"
            :key="PromotionOfferItemIndex"
            class="desg-list11"
          >
            <td style="">
              <div class="d-flex align-items-center">
                <StatusDot
                  :status="
                    PromotionOfferItem.os_is_active == 'Y'
                      ? 'active'
                      : PromotionOfferItem.os_is_active == 'N' && 'inactive'
                  "
                />
                <div class="ml-4 d-flex align-items-center">
                  <i
                    v-if="
                      cinema_manager_add_edit_disabled != 3 &&
                        $can('update', 'Promotions & Offers')
                    "
                    class="edit-pen icon blue-icon mr-2"
                    @click.prevent.stop="
                      onEditPromotionOffer(PromotionOfferItem)
                    "
                    style="cursor: pointer"
                    v-b-tooltip="'Edit'"
                    tabindex="0"
                  ></i>
                  <div
                    v-if="PromotionOfferItem.os_is_voucher === 'Y'"
                    class="icon-info blue-icon"
                    @click.prevent.stop="onViewVoucherCodes(PromotionOfferItem)"
                    style="cursor: pointer;"
                    v-b-tooltip="'View Voucher Codes'"
                    tabindex="0"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      fill="#8d6fbf"
                      class="bi bi-ticket-fill"
                      viewBox="0 0 18 18"
                    >
                      <path
                        d="M1.5 3A1.5 1.5 0 0 0 0 4.5V6a.5.5 0 0 0 .5.5 1.5 1.5 0 1 1 0 3 .5.5 0 0 0-.5.5v1.5A1.5 1.5 0 0 0 1.5 13h13a1.5 1.5 0 0 0 1.5-1.5V10a.5.5 0 0 0-.5-.5 1.5 1.5 0 0 1 0-3A.5.5 0 0 0 16 6V4.5A1.5 1.5 0 0 0 14.5 3h-13Z"
                      />
                    </svg>
                  </div>
                  <div
                    class="icon-info blue-icon"
                    @click.prevent.stop="
                      onViewPromotionOfferUsage(PromotionOfferItem)
                    "
                    style="cursor: pointer"
                    v-b-tooltip="'View Usages'"
                    tabindex="0"
                  >
                    <img src="@/assets/img/icons/logs-svgrepo-com.svg" alt="" />
                  </div>
                </div>
              </div>
            </td>
            <td
              :style="{
                color:
                  PromotionOfferItem.os_is_voucher === 'Y'
                    ? '#8794FA'
                    : 'black',
              }"
            >
              {{ PromotionOfferItem.offer_title }}
            </td>
            <td
              :style="{
                color:
                  PromotionOfferItem.os_is_voucher === 'Y'
                    ? '#8794FA'
                    : 'black',
              }"
            >
              {{
                PromotionOfferItem.os_is_voucher === "Y" ? "Voucher" : "Offer"
              }}</td
            >
            <td
              :style="{
                color:
                  PromotionOfferItem.os_is_voucher === 'Y'
                    ? '#8794FA'
                    : 'black',
              }"
            >
              {{ formatDate(PromotionOfferItem.offer_start_date_time) }}
            </td>
            <td
              :style="{
                color:
                  PromotionOfferItem.os_is_voucher === 'Y'
                    ? '#8794FA'
                    : 'black',
              }"
            >
              {{ formatDate(PromotionOfferItem.offer_end_date_time) }}
            </td>
            <td style="">
              <StatusDot
                :status="
                  PromotionOfferItem.offer_redeem_at_online == 'Y'
                    ? 'active'
                    : PromotionOfferItem.offer_redeem_at_online == 'N' &&
                      'inactive'
                "
              />
            </td>
            <td style="">
              <StatusDot
                :status="
                  PromotionOfferItem.offer_redeem_at_boxoffice == 'Y'
                    ? 'active'
                    : PromotionOfferItem.offer_redeem_at_boxoffice == 'N' &&
                      'inactive'
                "
              />
            </td>
            <td style="">
              <StatusDot
                :status="
                  PromotionOfferItem.offer_redeem_at_concession == 'Y'
                    ? 'active'
                    : PromotionOfferItem.offer_redeem_at_concession == 'N' &&
                      'inactive'
                "
              />
            </td>
            <td
              :style="{
                color:
                  PromotionOfferItem.os_is_voucher === 'Y'
                    ? '#8794FA'
                    : 'black',
              }"
            >
              {{
                getOfferGroupTypeName(PromotionOfferItem.offer_group_type_id)
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <table class="w-100" v-if="promotionsAndOffersList.length === 0">
        <tbody>
          <tr class="desg-list-header11">
            <td colspan="2">
              <NoRecords />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
  import MarketingService from "@/services/MarketingService";
  import StatusDot from "@/components/Partials/StatusDot.vue";
  import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
  import NoRecords from "@/components/Partials/NoRecords.vue";

  export default {
    components: {
      StatusDot,
      FilterByStatusDropdown,
      NoRecords,
    },
    data() {
      return {
        perPage: 10,
        currentPage: 1,
        rows: 0,
        selectedvalue: "10",
        titleName: "Offer",
        offerSelected: true,
        voucherSelected: false,

        gridView: false,
        listView: true,
        promotionsAndOffersList: [],
        selectedOfferVouchertype: [
          { id: 1, type: "All" },
          { id: 2, type: "Offer" },
          { id: 3, type: "Voucher" },
        ],
        selectedOfferVoucherTypeName: "All",
        offerSelected: true,
        voucherSelected: false,
        debounce: null,
        searchValue: "",

        //Sorting data
        isSort: false,
        isAscending: true,
        orderby: "",
        columnName: "",
        offerGroupTypes: [],
        selectedOfferGroupType: { ogt_id: 0, ogt_type_name: "All" },
        filter_is_active: "Y",
      };
    },
    mounted() {
      this.getPromotionsAndOffersList();
      this.getOfferGroupType();
    },
    beforeMount() {
      this.cinema_manager_add_edit_disabled = this.secureStore.get(
        "USINFO"
      ).role_id;

      this.getviewingnumber();
    },
    computed: {
      viewingRange() {
        if (this.rows === 0) {
          return "Viewing 0 to 0 of 0";
        }

        const start = (this.currentPage - 1) * this.perPage + 1;
        const end = Math.min(this.currentPage * this.perPage, this.rows);

        return `Viewing ${start} to ${end} of ${this.rows}`;
      },
      selectedOfferGroupTypeName() {
        return this.selectedOfferGroupType
          ? this.selectedOfferGroupType.ogt_type_name
          : "";
      },
    },

    methods: {
      onOfferVoucherTypeChange(groupType) {
        this.selectedOfferVoucherTypeName = groupType.type;
        console.log(
          "Selected Offer Voucher Type:",
          this.selectedOfferVoucherTypeName
        );
        this.getPromotionsAndOffersList();
      },
      toggleSelection(selectedOption) {
        if (selectedOption === "offer") {
          this.titleName = "Offer";
          this.voucherSelected = false;
        } else if (selectedOption === "voucher") {
          this.titleName = "Voucher";
          this.offerSelected = false;
        }
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
          { name: "100", id: 6 },
        ];
      },
      getOfferGroupTypeName(offerGroupTypeId) {
        const selectedOfferGroupType = this.offerGroupTypes.find(
          (groupType) => groupType.ogt_id === offerGroupTypeId
        );
        return selectedOfferGroupType
          ? selectedOfferGroupType.ogt_type_name
          : "";
      },
      formatDate(dateString) {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        return day + "-" + month + "-" + year;
      },
      getviewingnumber() {
        this.viewingnumbers = [
          { name: "All", id: 1 },
          { name: "10", id: 2 },
          { name: "20", id: 3 },
          { name: "30", id: 3 },
          { name: "40", id: 4 },
          { name: "50", id: 5 },
          { name: "100", id: 6 },
        ];
      },
      onDropDownChangeValue(event) {
        if (event == "All") {
          this.perPage = this.rows;
          this.selectedvalue = event;
          this.onChangePagination();
        } else {
          console.log("Numbers :", event);
          this.selectedvalue = event;
          this.perPage = event;
          console.log("perPage :", this.perPage);
          this.onChangePagination();
        }
      },
      /* eslint-disable */
      onChangePagination: function(event) {
        // console.log(event);
        if (event === undefined) {
          this.currentPage = 1;
          this.getPromotionsAndOffersList();
        } else {
          this.currentPage = event;
          this.getPromotionsAndOffersList();
        }
      },
      //Sort
      onSortValue(columnName, orderby) {
        this.isSort = true;
        this.isAscending = !this.isAscending;
        this.columnName = columnName;
        this.orderby = orderby;
        this.getPromotionsAndOffersList();
      },
      onOfferGroupTypeChange(groupType) {
        this.selectedOfferGroupType = groupType;
        this.getPromotionsAndOffersList();
      },
      getOfferGroupType() {
        let payload = {
          status: "Active",
        };
        MarketingService.GetAllOfferGroupType(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.offerGroupTypes = [
                  { ogt_id: 0, ogt_type_name: "All" },
                  ...data.Records,
                ];
              } else {
                console.log("Error:", data.message);
                this.$toasted.show(data.message);
              }
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      },
      getPromotionsAndOffersList: function() {
        this.promotionsAndOffersList = [];
        let payload = {
          limit: this.perPage,
          currentPage: this.currentPage,
          columnName: this.columnName,
          orderBy: this.orderby,
          searchValue: this.searchValue,
          status: this.filter_is_active || "Y",
          offer_group_type_id: this.selectedOfferGroupType.ogt_id
            ? this.selectedOfferGroupType.ogt_id
            : null,
          type: this.selectedOfferVoucherTypeName || "",
        };
        console.log(this.selectedOfferGroupType, "offergroup");
        MarketingService.GetPrmotionAndoffers(payload)
          .then((response) => {
            const { data } = response;
            if (data && data.status) {
              if (data.Records.length > 0) {
                this.promotionsAndOffersList = data.Records;
                this.rows = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      /* eslint-disable */
      onEditPromotionOffer: function({ os_id, os_is_new_offer_module }) {
        if (os_is_new_offer_module === "Y") {
          this.$router.push({
            path: "/marketing/edit-promotions-and-offers-new",
            query: { os_id },
          });
        } else {
          this.$router.push({
            path: "/marketing/edit-promotions-and-offers",
            query: { os_id },
          });
        }
      },
      onViewPromotionOffer: function({ os_id }) {
        this.$router.push({
          path: "/marketing/view-promotions-and-offers",
          query: { os_id },
        });
      },
      onViewPromotionOfferUsage: function({ os_id }) {
        this.$router.push({
          path: "/marketing/view-usage-promotions-and-offers",
          query: { os_id },
        });
      },
      onViewVoucherCodes: function({ os_id }) {
        this.$router.push({
          path: `/marketing/view-voucher-codes-new/${os_id}`,
        });
      },

      viewType: function(viewType) {
        if (viewType == "gridView") {
          this.gridView = true;
          this.listView = false;
        } else if ((viewType = "listView")) {
          this.listView = true;
          this.gridView = false;
        }
      },
    },
  };
</script>
<style>
  .desg-list-header11 th {
    padding: 0 30px;
    border-bottom: 1px solid #d3d3d3;
    -webkit-box-align: center;
    height: 45px;
  }

  table.w-100 tbody tr.desg-list11 td {
    border-bottom: 1px solid var(--lightgrey);
    height: 45px;
    padding: 0 30px;
  }

  table.w-100 tbody tr.desg-list11:last-child td {
    border-bottom: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/PromotionsAndOffersComponent/promotionsAndOffers.vue